import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import JumpStartArea from "../components/JumpStartArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const JumpStart = () => {
  return (
    <>
      <SEO canonical="/funding/jumpstart" {...PAGES["/funding/jumpstart"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab JumpStart"} />

      {/* Service Details Area */}
      <JumpStartArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default JumpStart;
